namespace RioERP.Orders {
    export namespace CounterOrdersService {
        export const baseUrl = 'Orders/CounterOrders';

        export declare function Create(request: Serenity.SaveRequest<CounterOrdersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CreateCounterOrder(request: Serenity.SaveRequest<CounterOrdersRow>, onSuccess?: (response: Serenity.RetrieveResponse<CounterOrdersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CounterOrdersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CounterOrdersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CounterOrdersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/CounterOrders/Create",
            CreateCounterOrder = "Orders/CounterOrders/CreateCounterOrder",
            Update = "Orders/CounterOrders/Update",
            Delete = "Orders/CounterOrders/Delete",
            Retrieve = "Orders/CounterOrders/Retrieve",
            List = "Orders/CounterOrders/List"
        }

        [
            'Create', 
            'CreateCounterOrder', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CounterOrdersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
